import { useSelector } from 'react-redux';

import dark from '/logo-dark.webp';
import light from '/logo-light.webp';

import appSelectors from 'redux/app/appSelectors';

import s from './logo.module.css';

const LOGO_IMG = { dark, light };

const LANDING_URL = import.meta.env.VITE_LANDING_URL;

function Logo() {
  const theme = useSelector(appSelectors.theme);

  return (
    <a
      href={LANDING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={s.logo}
    >
      <img src={LOGO_IMG[theme]} alt="logo" />
    </a>
  );
}

export default Logo;
